import { IncidentId } from '@collector/sportsapi-client-legacy'
import { useSportMaps } from '@desktop/views/Relation/composables'

import { injectCustomIncidentNames } from '../provide-inject'

export function useIncidentName(): {
  getIncidentName(incidentId: IncidentId): string
} {
  const { incidentIdToSportIncidentMap } = useSportMaps()
  const customIncidentNames = injectCustomIncidentNames()

  function getIncidentName(incidentId: IncidentId): string {
    const customName = customIncidentNames?.get(incidentId)

    if (customName) {
      return customName
    }

    const incident = incidentIdToSportIncidentMap.value[incidentId]

    return incident?.name ?? 'Unknown incident'
  }

  return {
    getIncidentName,
  }
}
